export default class Animation {
    /**
     * Shakes the element and removes the class at the end of the animation.
     *
     * @function shake
     * @param {Element} element - The element.
     * @returns {void}
     */
    static shakeSubtle(element) {
        element.classList.add('shake-subtle');
        element.addEventListener(
            'animationend',
            () => {
                element.classList.remove('shake-subtle');
            },
            { once: true }
        );
    }
}
